import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageCircle, Phone } from "lucide-react";
import { getWhatsAppUrl, PHONE_PRIMARY_TEL, PHONE_PRIMARY } from "@/lib/constants";

interface CTABannerProps {
  title?: string;
  subtitle?: string;
  whatsappMessage?: string;
}

const CTABanner = ({
  title = "Ready to Transform Your Smile?",
  subtitle = "Book a consultation with Dr. Khushboo Mutha today",
  whatsappMessage,
}: CTABannerProps) => (
  <section className="bg-primary text-primary-foreground py-12 md:py-16">
    <div className="container text-center">
      <h2 className="font-heading text-2xl md:text-3xl font-bold mb-3">{title}</h2>
      <p className="text-primary-foreground/90 mb-6 max-w-xl mx-auto">{subtitle}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Button asChild size="lg" variant="secondary">
          <a href={getWhatsAppUrl(whatsappMessage)} target="_blank" rel="noopener noreferrer">
            <MessageCircle className="h-5 w-5 mr-2" /> WhatsApp Us
          </a>
        </Button>
        <Button asChild size="lg" variant="outline" className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10">
          <a href={PHONE_PRIMARY_TEL}>
            <Phone className="h-5 w-5 mr-2" /> {PHONE_PRIMARY}
          </a>
        </Button>
      </div>
    </div>
  </section>
);

export default CTABanner;
